import { NavLink } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import navigationLinks from '../data/navigation';

const Header = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRefs = useRef({});
  const headerLogo = `${process.env.PUBLIC_URL}/logo-header.png`;

  const primaryLinks = navigationLinks.filter((link) => link.topLevel);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (activeDropdown && dropdownRefs.current[activeDropdown] &&
          !dropdownRefs.current[activeDropdown].contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [activeDropdown]);

  const handleDropdownToggle = (label) => {
    setActiveDropdown(activeDropdown === label ? null : label);
  };
  
  const handleLinkClick = () => {
    setActiveDropdown(null);
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={toggleMobileMenu}
          aria-hidden="true"
        />
      )}
      <header>
        <div className="container header-inner">
          <NavLink to="/" className="brand header-logo" end aria-label="Nexus IT home">
            <img src={headerLogo} alt="Nexus IT logo" />
            <span className="sr-only">Nexus Unified Solution & Consultancy Services</span>
          </NavLink>
          
          <button
            className="mobile-menu-toggle"
            type="button"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? (
              <svg className="close-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </>
            )}
          </button>
          
          <nav className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`} aria-label="Primary navigation">
            {isMobileMenuOpen && (
              <button
                className="mobile-menu-close"
                type="button"
                onClick={toggleMobileMenu}
                aria-label="Close mobile menu"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
            <ul>
              {primaryLinks.map((link) => (
                <li key={link.label} ref={(el) => dropdownRefs.current[link.label] = el}>
                  {link.dropdown ? (
                    <>
                      <button
                        type="button"
                        className={`nav-dropdown__toggle ${activeDropdown === link.label ? 'open' : ''}`}
                        onClick={() => handleDropdownToggle(link.label)}
                        aria-haspopup="true"
                        aria-expanded={activeDropdown === link.label}
                      >
                        {link.label}
                        <svg className="nav-dropdown__arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>
                      <ul className={`nav-dropdown__menu ${activeDropdown === link.label ? 'show' : ''}`}>
                        {link.dropdown.map((dropdownLink) => (
                          <li key={dropdownLink.to}>
                            <NavLink
                              to={dropdownLink.to}
                              end={dropdownLink.end}
                              className={({ isActive }) => (isActive ? 'active' : undefined)}
                              onClick={handleLinkClick}
                            >
                              {dropdownLink.label}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <NavLink
                      to={link.to}
                      end={link.end}
                      className={({ isActive }) => (isActive ? 'active' : undefined)}
                      onClick={handleLinkClick}
                    >
                      {link.label}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
